import { auth } from 'firebase/config';
import { setDoc, doc, query, where, getDocs, collection } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';

export const setDocWithCreatedBy = async (Collection, data) => {
  const docRef = doc(Collection);
  data.id = docRef.id;
  const { parentId: parentUserId, uid } = await getCurrentUserData()
  const parentOwner = {
    ownerId: uid,
    parentUserId
  }
  await setDoc(docRef, { ...data, ...parentOwner });
  return { ...data, ...parentOwner };
};

export function getCurrentUserUID() {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      if (user) resolve(user.uid);
      else reject('No user logged in');
    });
  });
}
export async function getToken() {
  return auth.currentUser?.getIdToken(true);
}
export async function getCurrentUserData() {
  const { claims } = await auth.currentUser?.getIdTokenResult(true)
  const token = await getToken();
  
  return { uid: claims.user_id, parentId: claims?.parentId, role: claims?.role, name: claims?.name ,token: token};
}

// Función para verificar si el usuario actual tiene rol de administrador
export async function isUserAdmin() {
  try {
    const { claims } = await auth.currentUser?.getIdTokenResult(true);
    // Verificar si el usuario tiene el rol de administrador en los claims
    return claims?.role === 'admin';
  } catch (error) {
    console.error('Error al verificar rol de administrador:', error);
    return false;
  }
}
